import ACTIONS from "../../constants/actions";

const initialState = {
	trackerId : null,
	isOpen    : false
};

export default function tracker(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.TRACKER.SET: {
			return Object.assign({}, {...state}, {trackerId : action.trackerId, isOpen : true});
		}
		case ACTIONS.TRACKER.TOGGLE: {
			return Object.assign({}, {...state}, {isOpen : !state.isOpen});
		}
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/tracker.js